// extracted by mini-css-extract-plugin
var _1 = "ShareDropdown__ShareDropdown___eoFzk";
var _2 = "ShareDropdown__dropdown___SwAaZ";
var _3 = "ShareDropdown__open___wam5w";
var _4 = "ShareDropdown__wiggle___yrwF7";
export { _1 as "ShareDropdown", _2 as "dropdown", _3 as "open", _4 as "wiggle" }
